export default "__VITE_ASSET__BbGBjzdb__"